module.exports = __webpack_public_path__ + "img/20200707_103608.ec4506c4.jpg";